export class GetPendingLettersListRequest {
    KeywordSearches: string[];
    PageNumber: number;
    ItemsPerPage: number;
    Sorting: number;
    StatusSearch: number;
}
